import React from 'react';

import { TRecommendation } from '@/services/requests/Recommendation/types/template1';

import { getValue } from '@/helpers/GetValueHelper';

import { CardOffer } from './CardOffer';

type TOfferGroupProps = {
  data: TRecommendation;
};

export const CardOfferGroup = ({ data }: TOfferGroupProps) => {
  const { cards } = data;

  return (
    <div className="vitrine-template1__offergroup">
      <div className="vitrine-template1__offers" data-testid="offers">
        {cards.map(
          card =>
            (getValue(card, 'type', '') as string).indexOf('tag') > -1 && (
              <CardOffer key={card.id} data={card} />
            ),
        )}
      </div>
    </div>
  );
};
